export default __webpack_public_path__ + "static/media/pexels-pixabay-273209.122466e7.jpg";